import React, { FC, useEffect, useState } from 'react';
import {
	Dialog,
	DialogTitle,
	FormControl,
	FormLabel,
	InputLabel,
	Radio,
	RadioGroup,
	SelectChangeEvent,
	FormGroup,
	Tooltip
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import styles from './SettingsForm.module.css';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { setErrorApp, setInfoApp } from '../../store/reducers/InfoSlice';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
	DEF_CACHING,
	DEF_LOWER_READINGS,
	DEF_GOOD_BUY_TEXT,
	DEF_HELLO_TEXT,
	DEF_INFO_MESSAGE,
	DEF_INPUT_TYPE,
	DEF_LS_MESSAGE_DTMF,
	DEF_LS_MESSAGE_DTMF_VOICE,
	DEF_LS_MESSAGE_VOICE,
	DEF_METER_MESSAGE_DTMF,
	DEF_METER_MESSAGE_DTMF_VOICE,
	DEF_METER_MESSAGE_VOICE,
	SCHEDULE_TYPE,
	GETTER_START,
	GETTER_END,
	SCHEDULE_TEXT,
	RECORDING,
	GMT,
	DEF_VOICE,
	BITRIX_INTEGRATION,
	TYPE_SERVICE,
	URL_DATA_EXCHANGER,
	DEF_USE_DOUBLE_VALUES,
	DEF_METER_MESSAGE_VOICE_DOUBLE,
	DEF_METER_MESSAGE_DTMF_DOUBLE,
	DEF_METER_MESSAGE_DTMF_VOICE_DOUBLE,
	DEF_VOICE_METER_NUMBER,
	DEF_USE_SERVICE_FILTER,
} from '../../utils/const';
import PlayTextButton from '../PlayTextButton/PlayTextButton';
import PlayDialogButton from '../PlayDialogButton/PlayDialogButton';
import {
	setTaskGetter,
	returnTasks,
	offTaskGetter,
} from '../../service/TasksService';
import { fetchProfile } from '../../service/ProfileServiceThunk';
import { setBalanceModal, setSettingsModal } from '../../store/reducers/ModalSlice';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IService } from '../../models/IProfile';
import { getServices } from '../../service/UsersService';

type SettingsFormsProps = {
	open: boolean,
	setClose: (value: boolean) => void,
};

const SettingsForm: FC<SettingsFormsProps> = ({ open, setClose }) => {
	const { profile } = useAppSelector((state) => state.profileReducer);
	const dispatch = useAppDispatch();
	const [sending, setSending] = useState<boolean>(false);
	const [expanded, setExpanded] = React.useState<string | false>(false);

	const handleChangeAccordion =
		(panel: string) => (evt: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : false);
		};

	interface IDictionary {
		[key: string]: string;
	}
	const dictionary: IDictionary = {
		autocall: 'Обзвоне должников',
		getter: 'Приеме показаний',
		shop: 'Подтверждении заказов',
	};

	useEffect(() => {
		if (open) {
			handleOpenSettings();
		}
	}, [open]);

	useEffect(() => {
		if (profile) {
			setVoice(profile.voice_getter ?? 'oksana');
			setGmt(profile.gmt_getter || '3');
		}
	}, [profile]);

	const initInputType = () => {
		if (profile?.input_type && profile?.tariff === 'advanced') {
			return profile?.input_type;
		} else if (profile?.input_type && profile?.tariff === 'basic') {
			return 'DTMFinput';
		} else if (profile?.input_type) {
			return profile?.input_type;
		}
		return DEF_INPUT_TYPE;
	};

	const initHelloText = () => {
		if (profile?.hello_text) return profile?.hello_text;
		return DEF_HELLO_TEXT;
	};
	const initLsMessage = (): string => {
		if (inputType === 'voiceInput') {
			if (profile?.ls_message_voice) return profile?.ls_message_voice;
			else return DEF_LS_MESSAGE_VOICE;
		} else if (inputType === 'DTMFinput') {
			if (profile?.ls_message_dtmf) return profile?.ls_message_dtmf;
			else return DEF_LS_MESSAGE_DTMF;
		} else if (inputType === 'voiceDTMF') {
			if (profile?.ls_message_voice_dtmf) return profile?.ls_message_voice_dtmf;
			else return DEF_LS_MESSAGE_DTMF_VOICE;
		} else return DEF_LS_MESSAGE_VOICE;
	};

	const setLsMessageForReq = (type: string) => {
		if (type === 'voiceInput') {
			if (profile?.ls_message_voice) return profile?.ls_message_voice;
			else return DEF_LS_MESSAGE_VOICE;
		} else if (type === 'DTMFinput') {
			if (profile?.ls_message_dtmf) return profile?.ls_message_dtmf;
			else return DEF_LS_MESSAGE_DTMF;
		} else if (type === 'voiceDTMF') {
			if (profile?.ls_message_voice_dtmf) return profile?.ls_message_voice_dtmf;
			else return DEF_LS_MESSAGE_DTMF_VOICE;
		}
		return '';
	};

	const setMeterMessageForReq = (type: string) => {
		if (type === 'voiceInput') {
			if (profile?.meter_message_voice) return profile?.meter_message_voice;
			else return DEF_METER_MESSAGE_VOICE;
		} else if (type === 'DTMFinput') {
			if (profile?.meter_message_dtmf) return profile?.meter_message_dtmf;
			else return DEF_METER_MESSAGE_DTMF;
		} else if (type === 'voiceDTMF') {
			if (profile?.meter_message_voice_dtmf)
				return profile?.meter_message_voice_dtmf;
			else return DEF_METER_MESSAGE_DTMF_VOICE;
		} else return '';
	};

	const returnLsMessage = (type: string) => {
		if (type === inputType) {
			return lsMessage;
		} else {
			return setLsMessageForReq(type);
		}
	};

	const returnMeterMessage = (type: string) => {
		if (type === inputType) {
			return meterMessage;
		} else {
			return setMeterMessageForReq(type);
		}
	};

	const returnSheduleParams = (params: string) => {
		if (scheduleType === 'schedule' && params === 'getterStart') {
			return getterStart;
		} else if (scheduleType === 'schedule' && params === 'getterEnd') {
			return getterEnd;
		} else if (scheduleType === 'schedule' && params === 'schedule_text') {
			return scheduleText;
		} else return undefined;
	};

	const initMeterMessage = () => {
		if (inputType === 'voiceInput') {
			if (profile?.meter_message_voice) return profile?.meter_message_voice;
			else return profile?.useDoubleValues || DEF_USE_DOUBLE_VALUES ? DEF_METER_MESSAGE_VOICE_DOUBLE : DEF_METER_MESSAGE_VOICE;
		} else if (inputType === 'DTMFinput') {
			if (profile?.meter_message_dtmf) return profile?.meter_message_dtmf;
			else return profile?.useDoubleValues || DEF_USE_DOUBLE_VALUES ? DEF_METER_MESSAGE_DTMF_DOUBLE : DEF_METER_MESSAGE_DTMF;
		} else if (inputType === 'voiceDTMF') {
			if (profile?.meter_message_voice_dtmf)
				return profile?.meter_message_voice_dtmf;
			else return profile?.useDoubleValues || DEF_USE_DOUBLE_VALUES ? DEF_METER_MESSAGE_DTMF_VOICE_DOUBLE : DEF_METER_MESSAGE_DTMF_VOICE;
		} else return profile?.useDoubleValues || DEF_USE_DOUBLE_VALUES ? DEF_METER_MESSAGE_VOICE_DOUBLE : DEF_METER_MESSAGE_VOICE;
	};

	const initInfoMessage = () => {
		if (profile?.info_message) return profile?.info_message;
		return DEF_INFO_MESSAGE;
	};
	const initGoodbyeText = () => {
		if (profile?.good_buy_text) return profile?.good_buy_text;
		return DEF_GOOD_BUY_TEXT;
	};
	const initCaching = () => {
		if (profile?.caching) return profile?.caching;
		return DEF_CACHING;
	};
	const initLowerReadings = () => {
		if (profile?.lowerReadings === false)
			return profile?.lowerReadings;
		return DEF_LOWER_READINGS;
	};
	const initUseDoubleValues = () => {
		if (profile?.useDoubleValues)
			return profile?.useDoubleValues;
		return DEF_USE_DOUBLE_VALUES;
	};
	const initUseServiceFilter = () => {
		if (profile?.use_service_filter !== undefined)
			return profile?.use_service_filter;
		return DEF_USE_SERVICE_FILTER;
	};
	const initScheduleType = () => {
		if (profile?.scheduleType) return profile?.scheduleType;
		return SCHEDULE_TYPE;
	};
	const initGetterStart = () => {
		if (profile?.getterStart) return profile?.getterStart;
		return GETTER_START;
	};
	const initGetterEnd = () => {
		if (profile?.getterEnd) return profile?.getterEnd;
		return GETTER_END;
	};
	const initScheduleText = () => {
		if (profile?.schedule_text) return profile?.schedule_text;
		return SCHEDULE_TEXT;
	};
	const initRecording = () => {
		if (profile?.recording_getter === false)
			return profile?.recording_getter;
		return RECORDING;
	};
	const initGMT = () => {
		if (profile?.gmt_getter) return profile?.gmt_getter;
		return GMT;
	};
	const initBitrixIntegration = () => {
		if (profile?.bitrix_integration_getter === false)
			return profile?.bitrix_integration_getter;
		return BITRIX_INTEGRATION;
	};
	const initVoiceMeterNumber = () => {
		if (profile?.voice_meter_number === true)
			return profile?.voice_meter_number;
		return DEF_VOICE_METER_NUMBER;
	};

	const initSelectedServices = () => {
		if (profile?.service_filter_list !== undefined && typeof profile?.service_filter_list === 'string') {
			const parsedList = JSON.parse(profile?.service_filter_list);
			return parsedList;
		}
		return [];
	};

	const [inputType, setInputType] = useState<string>(initInputType);
	const [gmt, setGmt] = useState<string>(initGMT);
	const [goodbyeText, setGoodbyeText] = useState<string>(initGoodbyeText);
	const [infoMessage, setInfoMessage] = useState<string>(initInfoMessage);
	const [meterMessage, setMeterMessage] = useState<string>(initMeterMessage);
	const [helloText, setHelloText] = useState<string>(initHelloText);
	const [lsMessage, setLsMessage] = useState<string>(initLsMessage);
	const [voice, setVoice] = useState<string>(profile?.voice_getter ?? 'oksana');
	const [caching, setCaching] = useState<boolean>(initCaching);
	const [lowerReadings, setLowerReadings] = useState<boolean>(initLowerReadings);
	const [useDoubleValues, setUseDoubleValues] = useState<boolean>(initUseDoubleValues);
	const [scheduleType, setScheduleType] = useState<string>(initScheduleType);
	const [getterStart, setGetterStart] = useState<string>(initGetterStart);
	const [getterEnd, setGetterEnd] = useState<string>(initGetterEnd);
	const [scheduleText, setScheduleText] = useState<string>(initScheduleText);
	const [recording, setRecording] = useState<boolean>(initRecording);
	const [task, setCurrentTask] = useState<boolean>(false);
	const [bitrixIntegration, setBitrixIntegration] = useState<boolean>(
		initBitrixIntegration
	);
	const [preventStartTask, setPreventStartTask] = useState<string>('');
	const [voiceMeterNumber, setVoiceMeterNumber] = useState<boolean>(initVoiceMeterNumber);
	const [selectedServices, setSelectedServices] = useState<IService[]>(() => initSelectedServices());
	const [useServiceFilter, setUseServiceFilter] = useState<boolean>(initUseServiceFilter);

	const handleServiceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const serviceName = event.target.name;
		const updatedSelectedServices = selectedServices.map(service => {
			if (service.name === serviceName) {
				return { ...service, active: !service.active };
			}
			return service;
		});
		setSelectedServices(updatedSelectedServices);

		const anyServiceActive = updatedSelectedServices.some(service => service.active);
		setUseServiceFilter(anyServiceActive || updatedSelectedServices.length === 0);
	};

	const setDefaultSettings = () => {
		setGmt(GMT);
		setHelloText(DEF_HELLO_TEXT);
		if (inputType === 'voiceInput') {
			setLsMessage(DEF_LS_MESSAGE_VOICE);
		} else if (inputType === 'DTMFinput') {
			setLsMessage(DEF_LS_MESSAGE_DTMF);
		} else if (inputType === 'voiceDTMF') {
			setLsMessage(DEF_LS_MESSAGE_DTMF_VOICE);
		}
		resetMeterMessage(useDoubleValues, inputType);
		setInfoMessage(DEF_INFO_MESSAGE);
		setGoodbyeText(DEF_GOOD_BUY_TEXT);
		setVoice(DEF_VOICE);
		setCaching(DEF_CACHING);
		setVoiceMeterNumber(DEF_VOICE_METER_NUMBER);
		setLowerReadings(DEF_LOWER_READINGS);
		setScheduleType(SCHEDULE_TYPE);
		setScheduleText(SCHEDULE_TEXT);
		setRecording(RECORDING);
		setBitrixIntegration(BITRIX_INTEGRATION);
		setUseServiceFilter(DEF_USE_SERVICE_FILTER);
		setUseDoubleValues(DEF_USE_DOUBLE_VALUES);
		setInputType(DEF_INPUT_TYPE)
	};

	const resetMeterMessage = (value: boolean, type: string) => {
		if (type === 'voiceInput') {
			setMeterMessage(value ? DEF_METER_MESSAGE_VOICE_DOUBLE : DEF_METER_MESSAGE_VOICE);
		} else if (type === 'DTMFinput') {
			setMeterMessage(value ? DEF_METER_MESSAGE_DTMF_DOUBLE : DEF_METER_MESSAGE_DTMF);
		} else if (type === 'voiceDTMF') {
			setMeterMessage(value ? DEF_METER_MESSAGE_DTMF_VOICE_DOUBLE : DEF_METER_MESSAGE_DTMF_VOICE);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const handleOpenSettings = async () => {
		const response = await returnTasks();
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при проверке запущенных задач',
				})
			);
		} else {
			const { data } = response.data.data;
			const service = [];
			const translateService = (service: string) => {
				return dictionary[`${service}`];
			};
			for (const itemTask of data) {
				if (itemTask.nameFile.includes(TYPE_SERVICE)) {
					setCurrentTask(true);
				}
				if (itemTask.nameFile.includes('autocall')) service.push('autocall');
				if (itemTask.nameFile.includes('shop')) service.push('shop');
			}
			if (service.length > 0) {
				for (const item of service) {
					if (
						profile &&
						profile[`phone_${item}`] == profile[`phone_${TYPE_SERVICE}`]
					) {
						setPreventStartTask(translateService(item));
					}
				}
			}
		}
		//
		dispatch(
			setSettingsModal({
				show: true,
			})
		);
		// setOpenSet(true);
	};
	const handleCloseSettings = () => {
		setPreventStartTask('');

		dispatch(
			setSettingsModal({
				show: false,
			})
		);
		// setOpenSet(false);
	};

	const handleChange = (
		evt: React.ChangeEvent<HTMLInputElement>,
		type: string
	) => {
		if (type === 'helloText') {
			setHelloText(evt.target.value);
		} else if (type === 'lsMessage') {
			setLsMessage(evt.target.value);
		} else if (type === 'meterMessage') {
			setMeterMessage(evt.target.value);
		} else if (type === 'infoMessage') {
			setInfoMessage(evt.target.value);
		} else if (type === 'goodbyeText') {
			setGoodbyeText(evt.target.value);
		} else if (type === 'inputType') {
			setInputType(evt.target.value);
		} else if (type === 'scheduleType') {
			setScheduleType(evt.target.value);
		} else if (type === 'getterStart') {
			if (
				(/^\d+$/.test(evt.target.value) &&
					Number(evt.target.value) <= 31 &&
					Number(evt.target.value) >= 1) ||
				evt.target.value === ''
			) {
				setGetterStart(evt.target.value);
			}
		} else if (type === 'getterEnd') {
			if (
				(/^\d+$/.test(evt.target.value) &&
					Number(evt.target.value) <= 31 &&
					Number(evt.target.value) >= 1) ||
				evt.target.value === ''
			) {
				setGetterEnd(evt.target.value);
			}
		} else if (type === 'scheduleText') {
			if (
				(/^[a-zA-Z0-9\sа-яА-ЯёЁ]+$/.test(evt.target.value) &&
					evt.target.value.length <= 360) ||
				evt.target.value === ''
			) {
				setScheduleText(evt.target.value);
			}
		}
	};

	useEffect(() => {
		setLsMessage(initLsMessage);
		resetMeterMessage(useDoubleValues, inputType);
	}, [inputType]);

	useEffect(() => {
		setInputType(initInputType());
		setGetterStart(initGetterStart());
		setGetterEnd(initGetterEnd());
		setScheduleType(initScheduleType());
		setBitrixIntegration(initBitrixIntegration());
		setCaching(initCaching());
		setLowerReadings(initLowerReadings());
		setUseDoubleValues(initUseDoubleValues());
		setUseServiceFilter(initUseServiceFilter());
		setGoodbyeText(initGoodbyeText());
		setInfoMessage(initInfoMessage());
		setMeterMessage(initMeterMessage());
		setHelloText(initHelloText());
		setLsMessage(initLsMessage());
		setRecording(initRecording());
		setVoiceMeterNumber(initVoiceMeterNumber());
		setSelectedServices(initSelectedServices());
		setScheduleText(initScheduleText());
	}, [profile, open]);

	const changeHandler = (evt: any, type: string) => {
		if (type === 'caching') {
			setCaching(evt.target.checked);
		} else if (type === 'recording') {
			setRecording(evt.target.checked);
		} else if (type === 'voiceMeterNumber') {
			setVoiceMeterNumber(evt.target.checked);
		} else if (type === 'lowerReadings') {
			setLowerReadings(evt.target.checked);
		} else if (type === 'bitrix') {
			setBitrixIntegration(evt.target.checked);
		} else if (type === 'useServiceFilter') {
			setUseServiceFilter(evt.target.checked);
		} else if (type === 'useDoubleValues') {
			setUseDoubleValues(evt.target.checked);
			resetMeterMessage(evt.target.checked, inputType);
		}
	};

	const handleSelect = (evt: SelectChangeEvent<any>, type: string) => {
		if (type === 'voice') {
			setVoice(evt.target.value);
		} else if (type === 'gmt') {
			setGmt(evt.target.value);
		}
	};

	const setTask = async () => {
		if (
			helloText.length <= 0 || (!helloText.trim()) ||
			lsMessage.length <= 0 || (!lsMessage.trim()) ||
			meterMessage.length <= 0 || (!meterMessage.trim()) ||
			infoMessage.length <= 0 || (!infoMessage.trim()) ||
			goodbyeText.length <= 0 || (!goodbyeText.trim())
		) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Необходимо заполнить обязательные поля',
				})
			);
		}
		if (
			profile?.phone_getter === undefined ||
			profile?.phone_getter.length <= 0 ||
			profile?.phone_pass_getter === undefined ||
			profile?.phone_pass_getter.length <= 0 ||
			profile?.server_sip_getter === undefined ||
			profile?.server_sip_getter.length <= 0
		) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Необходимо настроить сип-аккаунт',
				})
			);
		}
		if (profile &&
			(
				!task && ((profile.tariff === 'basic' && profile.balance_getter_basic === 0) ||
					(profile.tariff === 'advanced' && profile.balance_getter_advanced === 0) ||
					(profile.tariff !== 'basic' && profile.tariff !== 'advanced' && profile.balance_getter_test === 0))
			)
		) {
			return dispatch(setBalanceModal({ show: true }));
		}
		if (task) {
			setSending(true);
			const response = await offTaskGetter(
				helloText,
				lsMessage,
				meterMessage,
				infoMessage,
				recording,
				gmt,
				inputType,
				returnLsMessage('voiceInput'),
				returnLsMessage('DTMFinput'),
				returnLsMessage('voiceDTMF'),
				returnMeterMessage('voiceInput'),
				returnMeterMessage('DTMFinput'),
				returnMeterMessage('voiceDTMF'),
				voice,
				goodbyeText,
				false,
				scheduleType,
				returnSheduleParams('getterStart'),
				returnSheduleParams('getterEnd'),
				returnSheduleParams('schedule_text'),
				caching,
				lowerReadings,
				bitrixIntegration,
				useDoubleValues,
				useServiceFilter && selectedServices ? selectedServices.some(service => service.active) : false,
				voiceMeterNumber,
				JSON.stringify(selectedServices),
			);
			if (response.error) {
				dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp: 'Произошла ошибка при выключении приема показаний',
					})
				);
				setSending(false);
			} else {
				const { success } = response.data.data;
				if (success === true) {
					dispatch(
						setInfoApp({
							isInfoApp: true,
							infoApp: 'Приём показаний успешно выключен!',
						})
					);
				}
				setSending(false);
				setCurrentTask(false);
				setClose(true);
			}
		} else {
			if (preventStartTask.length > 0) {
				handleCloseSettings();
				return dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp: `Данный сип-аккаунт уже используется в ${preventStartTask}`,
					})
				);
			}
			setSending(true);
			const response = await setTaskGetter(
				helloText,
				lsMessage,
				meterMessage,
				infoMessage,
				recording,
				gmt,
				inputType,
				returnLsMessage('voiceInput'),
				returnLsMessage('DTMFinput'),
				returnLsMessage('voiceDTMF'),
				returnMeterMessage('voiceInput'),
				returnMeterMessage('DTMFinput'),
				returnMeterMessage('voiceDTMF'),
				voice,
				goodbyeText,
				false,
				scheduleType,
				returnSheduleParams('getterStart'),
				returnSheduleParams('getterEnd'),
				returnSheduleParams('schedule_text'),
				caching,
				lowerReadings,
				bitrixIntegration,
				useDoubleValues,
				useServiceFilter && selectedServices ? selectedServices.some(service => service.active) : false,
				voiceMeterNumber,
				JSON.stringify(selectedServices),
			);
			if (response.error) {
				const { msg } = response.error.response.data;
				const textError =
					msg || 'Произошла ошибка при активации приема показаний';
				dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp: textError,
					})
				);
				setSending(false);
			} else {
				const { success } = response.data.data;
				if (success === true) {
					dispatch(
						setInfoApp({
							isInfoApp: true,
							infoApp: 'Приём показаний успешно активирован!',
						})
					);
				}
				setSending(false);
				setCurrentTask(true);
				setClose(true);
			}
			dispatch(fetchProfile());
		}
	};

	const saveSettings = async () => {	
		if (
			helloText.length <= 0 || (!helloText.trim()) ||
			lsMessage.length <= 0 || (!lsMessage.trim()) ||
			meterMessage.length <= 0 || (!meterMessage.trim()) ||
			infoMessage.length <= 0 || (!infoMessage.trim()) ||
			goodbyeText.length <= 0 || (!goodbyeText.trim())
		) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Необходимо заполнить обязательные поля',
				})
			);
		}
		if (!task) {
			setSending(true);
			const response = await offTaskGetter(
				helloText,
				lsMessage,
				meterMessage,
				infoMessage,
				recording,
				gmt,
				inputType,
				returnLsMessage('voiceInput'),
				returnLsMessage('DTMFinput'),
				returnLsMessage('voiceDTMF'),
				returnMeterMessage('voiceInput'),
				returnMeterMessage('DTMFinput'),
				returnMeterMessage('voiceDTMF'),
				voice,
				goodbyeText,
				false,
				scheduleType,
				returnSheduleParams('getterStart'),
				returnSheduleParams('getterEnd'),
				returnSheduleParams('schedule_text'),
				caching,
				lowerReadings,
				bitrixIntegration,
				useDoubleValues,
				useServiceFilter && selectedServices ? selectedServices.some(service => service.active) : false,
				voiceMeterNumber,
				JSON.stringify(selectedServices),
			);
			if (response) {
				dispatch(
					setInfoApp({
						isInfoApp: true,
						infoApp: 'Данные успешно сохранены!',
					})
				);
				setSending(false);
				setClose(true);
			}
			dispatch(fetchProfile());
		} else {
			setSending(true);
			const response = await offTaskGetter(
				helloText,
				lsMessage,
				meterMessage,
				infoMessage,
				recording,
				gmt,
				inputType,
				returnLsMessage('voiceInput'),
				returnLsMessage('DTMFinput'),
				returnLsMessage('voiceDTMF'),
				returnMeterMessage('voiceInput'),
				returnMeterMessage('DTMFinput'),
				returnMeterMessage('voiceDTMF'),
				voice,
				goodbyeText,
				false,
				scheduleType,
				returnSheduleParams('getterStart'),
				returnSheduleParams('getterEnd'),
				returnSheduleParams('schedule_text'),
				caching,
				lowerReadings,
				bitrixIntegration,
				useDoubleValues,
				useServiceFilter && selectedServices ? selectedServices.some(service => service.active) : false,
				voiceMeterNumber,
				JSON.stringify(selectedServices),
			);
			if (response.error) {
				dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp: 'Произошла ошибка при сохранение данных!',
					})
				);
				setSending(false);
			} else {
				const { success } = response.data.data;
				if (success === true) {
					const responseSetTasks = await setTaskGetter(
						helloText,
						lsMessage,
						meterMessage,
						infoMessage,
						recording,
						gmt,
						inputType,
						returnLsMessage('voiceInput'),
						returnLsMessage('DTMFinput'),
						returnLsMessage('voiceDTMF'),
						returnMeterMessage('voiceInput'),
						returnMeterMessage('DTMFinput'),
						returnMeterMessage('voiceDTMF'),
						voice,
						goodbyeText,
						false,
						scheduleType,
						returnSheduleParams('getterStart'),
						returnSheduleParams('getterEnd'),
						returnSheduleParams('schedule_text'),
						caching,
						lowerReadings,
						bitrixIntegration,
						useDoubleValues,
						useServiceFilter,
						voiceMeterNumber,
						JSON.stringify(selectedServices),
					);
					if (responseSetTasks.error) {
						dispatch(
							setErrorApp({
								isErrorApp: true,
								errorApp: 'Произошла ошибка при сохранение данных!',
							})
						);
						setSending(false);
					} else {
						const { success } = responseSetTasks.data.data;
						if (success === true) {
							dispatch(
								setInfoApp({
									isInfoApp: true,
									infoApp: 'Данные успешно сохранены!',
								})
							);
							dispatch(fetchProfile());
						}
						setSending(false);
					}
				} else {
					setSending(false);
				}
			}
		}
	};

	const handleUpdate1CServices = async () => {
		setSending(true);
		const response = await getServices();
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при обновлении спика сервисов 1С',
				})
			);
			setSending(false);
		} else {
			dispatch(
				setInfoApp({
					isInfoApp: true,
					infoApp: 'Данные успешно обновлены!',
				})
			);
			setSending(false);
			dispatch(fetchProfile());
		}
	};

	return (
		<Dialog scroll="body" open={open} onClose={() => setClose(true)}>
			<DialogTitle className={styles.profile_label}>
				Настройки сценария
				<button onClick={() => setClose(true)} className={styles.close_modal}>
					×
				</button>
			</DialogTitle>
			<div className={styles.container}>
				<div className={styles.wrapper_for_block}>
					<Accordion
						sx={{ boxShadow: '0px 1px 1px 0px rgba(0,0,0,0.1)' }}
						expanded={expanded === 'panel1'}
						onChange={handleChangeAccordion('panel1')}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1bh-content"
							id="panel1bh-header"
						>
							<Typography>Интеграция с 1С ЖКХ</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<FormControlLabel
								className={styles.bitrix}
								control={<Checkbox />}
								onChange={(evt: React.SyntheticEvent<any>) =>
									changeHandler(evt, 'bitrix')
								}
								checked={bitrixIntegration}
								label="Активация"
								labelPlacement="end"
							/>
							{bitrixIntegration ? (
								<>
									<div className={styles.wrapper_text}>
										<TextField
											margin="dense"
											disabled
											id="url_server"
											label="Адрес сервера"
											fullWidth
											variant="standard"
											value={URL_DATA_EXCHANGER}
										/>
									</div>
									<div className={styles.wrapper_text}>
										<TextField
											margin="dense"
											disabled
											id="login"
											label="Логин"
											fullWidth
											variant="standard"
											value={profile?.login}
										/>
									</div>
									<div className={styles.wrapper_text}>
										<TextField
											margin="dense"
											disabled
											id="password"
											label="Пароль"
											fullWidth
											variant="standard"
											value={atob(profile?.encryptedPassword_getter ?? '')}
										/>
									</div>
								</>
							) : null}
						</AccordionDetails>
					</Accordion>
				</div>
				<div className={styles.wrapper_for_block}>
					<Accordion
						sx={{ boxShadow: '0px 1px 1px 0px rgba(0,0,0,0.1)' }}
						expanded={expanded === 'panel2'}
						onChange={handleChangeAccordion('panel2')}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel2bh-content"
							id="panel2bh-header"
						>
							<Typography>Настройки сценария</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<DialogContent
								className={`${styles.dialog_content} change-input-outlined-clock`}
							>
								<div className={styles.wrapper_text}>
									<TextField
										margin="dense"
										id="new_name"
										label="Приветствие"
										fullWidth
										variant="standard"
										value={helloText}
										onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
											handleChange(evt, 'helloText')
										}
										error={helloText.length <= 0 || (!helloText.trim())}
									/>
									<PlayTextButton voice={voice} text={helloText} />
								</div>
								<div className={styles.wrapper_text}>
									<TextField
										margin="dense"
										id="new_name"
										label="Просьба ввода лицевого счёта"
										fullWidth
										variant="standard"
										value={lsMessage}
										onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
											handleChange(evt, 'lsMessage')
										}
										error={lsMessage.length <= 0 || (!lsMessage.trim())}
									/>
									<PlayTextButton voice={voice} text={lsMessage} />
								</div>
								<div className={styles.wrapper_text}>
									<TextField
										margin="dense"
										id="new_name"
										label="Просьба ввода показаний счётчика"
										fullWidth
										variant="standard"
										value={meterMessage}
										onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
											handleChange(evt, 'meterMessage')
										}
										error={meterMessage.length <= 0 || (!meterMessage.trim())}
									/>
									<PlayTextButton voice={voice} text={meterMessage} />
								</div>
								<div className={styles.wrapper_text}>
									<TextField
										margin="dense"
										id="new_name"
										label="Информационное сообщение"
										fullWidth
										variant="standard"
										value={infoMessage}
										onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
											handleChange(evt, 'infoMessage')
										}
										error={infoMessage.length <= 0 || (!infoMessage.trim())}
									/>
									<PlayTextButton voice={voice} text={infoMessage} />
								</div>
								<div className={styles.wrapper_text}>
									<TextField
										margin="dense"
										id="new_name"
										label="Прощание"
										fullWidth
										variant="standard"
										value={goodbyeText}
										onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
											handleChange(evt, 'goodbyeText')
										}
										error={goodbyeText.length <= 0 || (!goodbyeText.trim())}
									/>
									<PlayTextButton voice={voice} text={goodbyeText} />
								</div>
								<div>
									<p>
										<b>Прослушать диалог целиком</b>
									</p>
									<PlayDialogButton
										voice={voice}
										helloText={helloText}
										lsMessage={lsMessage}
										goodbyeText={goodbyeText}
										infoMessage={infoMessage}
										meterMessage={meterMessage}
									/>
								</div>
							</DialogContent>
						</AccordionDetails>
					</Accordion>
				</div>
				<div className={styles.wrapper_for_block}>
					<Accordion
						sx={{ boxShadow: '0px 1px 1px 0px rgba(0,0,0,0.1)' }}
						expanded={expanded === 'panel3'}
						onChange={handleChangeAccordion('panel3')}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel3bh-content"
							id="panel3bh-header"
						>
							<Typography>Настройки параметров приема</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<DialogContent
								className={`${styles.dialog_content} change-input-outlined-clock-width`}>
								<InputLabel id="demo-simple-select-label">Часовой пояс</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={gmt}
									onChange={(evt: SelectChangeEvent<any>) =>
										handleSelect(evt, 'gmt')
									}
								>
									<MenuItem value={'2'}>GMT+02:00 Калининград</MenuItem>
									<MenuItem value={'3'}>GMT+03:00 Москва</MenuItem>
									<MenuItem value={'4'}>GMT+04:00 Майкоп</MenuItem>
									<MenuItem value={'5'}>GMT+05:00 Екатеринбург</MenuItem>
									<MenuItem value={'6'}>GMT+06:00 Омск</MenuItem>
									<MenuItem value={'7'}>GMT+07:00 Новосибирск</MenuItem>
									<MenuItem value={'8'}>GMT+08:00 Иркутск</MenuItem>
									<MenuItem value={'9'}>GMT+09:00 Якутск</MenuItem>
									<MenuItem value={'10'}>GMT+10:00 Владивосток</MenuItem>
									<MenuItem value={'11'}>GMT+11:00 Магадан</MenuItem>
									<MenuItem value={'12'}>
										GMT+12:00 Петропавловск-Камчатский
									</MenuItem>
								</Select>
							</DialogContent>
							<FormControl component="fieldset">
								<FormLabel component="legend">Способ ввода данных</FormLabel>
								<RadioGroup
									row
									aria-label="type_input"
									name="row-radio-buttons-group"
									value={inputType}
									onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
										handleChange(evt, 'inputType')
									}
								>
									<FormControlLabel
										value="voiceInput"
										control={<Radio />}
										label="голосом"
										disabled={
											profile?.tariff === 'basic' || profile?.tariff === null
										}
									/>
									<FormControlLabel
										value="DTMFinput"
										control={<Radio />}
										label="DTMF"
									/>
									<FormControlLabel
										value="voiceDTMF"
										control={<Radio />}
										label="голосом+DTMF"
										disabled={
											profile?.tariff === 'basic' || profile?.tariff === null
										}
									/>
								</RadioGroup>
							</FormControl>
							<div>
								<InputLabel
									className={styles.voice_input}
									id="demo-simple-select-label"
								>
									Выбор голоса
								</InputLabel>
								<Select
									className={`${styles.voice_select} change-input-outlined`}
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={voice}
									onChange={(evt: SelectChangeEvent<any>) =>
										handleSelect(evt, 'voice')
									}
								>
									<MenuItem value={'jane'}>jane</MenuItem>
									<MenuItem value={'oksana'}>oksana</MenuItem>
									<MenuItem value={'omazh'}>omazh</MenuItem>
									<MenuItem value={'zahar'}>zahar</MenuItem>
									<MenuItem value={'ermil'}>ermil</MenuItem>
								</Select>
							</div>
							<FormControl component="fieldset">
								<FormLabel component="legend">Расписание работы</FormLabel>
								<RadioGroup
									row
									aria-label="scheduleType"
									name="row-radio-buttons-group"
									value={scheduleType}
									onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
										handleChange(evt, 'scheduleType')
									}
								>
									<FormControlLabel
										value="always"
										control={<Radio />}
										label="Всегда"
									/>
									<FormControlLabel
										value="schedule"
										control={<Radio />}
										label="По расписанию"
									/>
									<div className={styles[`wrapper-${scheduleType}`]}>
										<TextField
											margin="dense"
											id="new_name"
											label="Число месяца включения"
											fullWidth
											variant="standard"
											value={getterStart}
											onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
												handleChange(evt, 'getterStart')
											}
											error={getterStart.length <= 0}
										/>
										<TextField
											margin="dense"
											id="new_name"
											label="Число месяца выключения"
											fullWidth
											variant="standard"
											value={getterEnd}
											onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
												handleChange(evt, 'getterEnd')
											}
											error={getterEnd.length <= 0}
										/>
										<TextField
											margin="dense"
											id="new_name"
											label="Сообщение о недоступности"
											fullWidth
											variant="standard"
											value={scheduleText}
											onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
												handleChange(evt, 'scheduleText')
											}
											error={scheduleText.length <= 0}
										/>
									</div>
								</RadioGroup>
							</FormControl>
							<div className={styles.line} />
							<FormControlLabel
								control={<Checkbox />}
								onChange={(evt: React.SyntheticEvent<any>) =>
									changeHandler(evt, 'lowerReadings')
								}
								checked={lowerReadings}
								label="Включить ограничение на подачу показаний меньше текущих"
								labelPlacement="end"
							/>
							<div className={styles.line} />
							<FormControlLabel
								control={<Checkbox />}
								onChange={(evt: React.SyntheticEvent<any>) =>
									changeHandler(evt, 'useDoubleValues')
								}
								checked={useDoubleValues}
								label="Принимать дробные показания"
								labelPlacement="end"
							/>
							<div className={styles.line} />
							<FormControlLabel
								control={<Checkbox />}
								onChange={(evt: React.SyntheticEvent<any>) =>
									changeHandler(evt, 'caching')
								}
								checked={caching}
								label="Включить привязку лицевых счетов к номеру телефона"
								labelPlacement="end"
							/>
							<div className={styles.line} />
							<FormControl component="fieldset">
								<FormGroup>
									<FormControlLabel
										control={<Checkbox
											checked={useServiceFilter}
											onChange={(evt: React.SyntheticEvent<any>) =>
												changeHandler(evt, 'useServiceFilter')
											}
										/>}
										label="Принимать показания по сервисам (список сервисов из 1C)"
									/>
									{useServiceFilter && (
										<>
											<Button className={styles.update_service} onClick={handleUpdate1CServices}>Обновить список сервисов 1С</Button>
											<div className={styles.service}>
												{Array.isArray(selectedServices) && selectedServices.length > 0 && selectedServices?.map(service => (
													<FormControlLabel
														key={service.id}
														control={<Checkbox
															checked={service.active}
															onChange={handleServiceChange}
															name={service.name}
														/>}
														label={service.name}
													/>
												))}
											</div>
										</>
									)}
								</FormGroup>
							</FormControl>
							<div className={styles.line} />
							<Tooltip
								followCursor
								arrow
								placement="top-start"
								title={
									<span
										style={{ fontSize: '12px' }}
									>
										Функционал доступен только для счетчиков, номера которых содержат последовательность из 4 и более цифр.
									</span>
								}
							>
								<FormControlLabel
									control={<Checkbox />}
									onChange={(evt: React.SyntheticEvent<any>) =>
										changeHandler(evt, 'voiceMeterNumber')
									}
									checked={voiceMeterNumber}
									label="Озвучивать номер счетчика (последние 4 цифры номера счетчика)"
									labelPlacement="end"
								/>
							</Tooltip>
							<div className={styles.line} />
							<FormControlLabel
								control={<Checkbox />}
								onChange={(evt: React.SyntheticEvent<any>) =>
									changeHandler(evt, 'recording')
								}
								checked={recording}
								label="Внимание! При включении опции, в начало диалога добавляется предупреждение абонента о записи телефонного звонка."
								labelPlacement="end"
							/>
						</AccordionDetails>
					</Accordion>
				</div>
				<DialogActions className={styles.dialogActions}>
					<Button onClick={() => setClose(true)}>Закрыть</Button>
					<Button onClick={setDefaultSettings}>Сбросить настройки</Button>
					<Button
						disabled={
							gmt === initGMT() &&
							helloText === initHelloText() &&
							lsMessage === initLsMessage() &&
							meterMessage === initMeterMessage() &&
							infoMessage === initInfoMessage() &&
							goodbyeText === initGoodbyeText() &&
							voice === profile?.voice_getter &&
							inputType === initInputType() &&
							caching === initCaching() &&
							lowerReadings === initLowerReadings() &&
							scheduleType === initScheduleType() &&
							getterStart === initGetterStart() &&
							getterEnd === initGetterEnd() &&
							scheduleText === initScheduleText() &&
							recording === initRecording() &&
							bitrixIntegration === initBitrixIntegration() &&
							selectedServices === initSelectedServices() &&
							useServiceFilter === initUseServiceFilter() &&
							voiceMeterNumber === initVoiceMeterNumber()
						}
						onClick={saveSettings}
					>
						Сохранить
					</Button>
					<Button onClick={setTask} disabled={sending}>
						{task ? 'Выключить' : 'Активировать'}
					</Button>
				</DialogActions>
				<DialogActions>
					{/*<Button onClick={onActivateLicence}>Активировать ключ</Button>*/}
				</DialogActions>
			</div>
		</Dialog>
	);
};

export default SettingsForm;
